<template>
    <div 
        :class="['floating-container', {
            isPC: !isH5
        }]"
    >
        <div
            :class="['move-container', basePoint]"
            ref="moveContainer"
        >
            <free-container 
                :children="tpl.children"
                ref="freeContainer"
            ></free-container>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { isH5 } from '../utils';
import { BASE_POINT } from '../constant';
import FEGOBridge from '@futuweb/fego-bridge';
const { rem } = FEGOBridge;

const {
    plugins: { ComplexComp }
} = require('@futuweb/fego-render');

export default Vue.extend({
    name: 'floating-container',
    props: ['tpl'],
    components: {
        FreeContainer: ComplexComp.Container.Free
    },
    data() {
        return {
            isH5: isH5(),
            listener: null
        }
    },
    computed: {
        basePoint() {
            return this.tpl.props.basePoint;
        }
    },
    mounted() {
        this.setFixed();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.listener);
    },
    methods: {
        // @tips 处理悬浮容器的定位
        // 在 editor 中配置时，h5下的宽高度为 7.5rem * 13.34re, pc 下为 19.2rem 与 10.8rem
        // h5 下针对底边的场景需要减去配置差值
        // pc 下针对右边的场景且宽度<1920需要减去配置差值 h5 下因为存在等比缩放，所以不需要这步操作
        setFixed() {
            const remStr = rem.rem.str;
            if (this.isH5) {
                // 如果基准点是底部的 配置里的高度是 13.34rem - 实际需要减掉
                if ([BASE_POINT.BOTTOM_LEFT, BASE_POINT.BOTTOM_MID, BASE_POINT.BOTTOM_RIGHT].includes(this.basePoint)) {
                    this.$refs.freeContainer.$el.style.top = `calc(100vh - 13.34rem)`;
                }
            } else {
                this.pcResizeListener();
                this.listener = () => {
                    this.pcResizeListener();
                }
                window.addEventListener('resize', this.listener);
            }
            this.$nextTick(() => {
                const { horizontal, vertical, basePoint } = this.tpl.props;  
                const moveContainer = this.$refs.moveContainer;
                const style = {
                    left: 'unset',
                    top: 'unset',
                    right: 'unset',
                    bottom: 'unset',
                };
                if (basePoint === BASE_POINT.TOP_LEFT) {
                    style.left = remStr(horizontal);
                    style.top = remStr(vertical);
                } else if (basePoint === BASE_POINT.TOP_MID) {
                    style.top = remStr(vertical);
                } else if (basePoint === BASE_POINT.TOP_RIGHT) {
                    style.top = remStr(vertical);
                    style.right = remStr(horizontal);
                } else if (basePoint === BASE_POINT.LEFT_MID) {
                    style.left = remStr(horizontal);
                } else if (basePoint === BASE_POINT.RIGHT_MID) {
                    style.right = remStr(horizontal);
                } else if (basePoint === BASE_POINT.BOTTOM_LEFT) {
                    style.left = remStr(horizontal);
                    style.bottom = remStr(vertical);
                } else if (basePoint === BASE_POINT.BOTTOM_MID) {
                    style.bottom = remStr(vertical); 
                } else if (basePoint === BASE_POINT.BOTTOM_RIGHT) {
                    style.right = remStr(horizontal);
                    style.bottom = remStr(vertical);
                }
                Object.keys(style).forEach(key => {
                    moveContainer.style[key] = style[key];
                })
            });
        },
        pcResizeListener() {
            const { width } = document.documentElement.getBoundingClientRect();
            // 在右侧的话，左侧偏移量需要减去 19.2rem
            if (width < 1920 && [BASE_POINT.TOP_RIGHT, BASE_POINT.RIGHT_MID, BASE_POINT.BOTTOM_RIGHT].includes(this.basePoint)) {
                this.$refs.freeContainer.$el.style.left = `calc(100vw - 19.2rem)`;
            } else {
                this.$refs.freeContainer.$el.style.left = `unset`;
            }
            if ([BASE_POINT.BOTTOM_LEFT, BASE_POINT.BOTTOM_MID, BASE_POINT.BOTTOM_RIGHT].includes(this.basePoint)) {
                this.$refs.freeContainer.$el.style.top = `calc(100vh - 10.8rem)`;
            }
        }
    }
});
</script>

<style lang="less" scoped>
.floating-container {
    pointer-events: none;
    // 注意 h5 下的要容器居中
    position: fixed!important;;
    width: 7.5rem!important;
    height: 100vh!important;
    // @tips 使内容在水平情况下居中
    left: 0!important;
    right: 0!important;
    top: 0!important;
    bottom: 0!important;
    margin: auto!important;

    .move-container {
        pointer-events: none;
        width: 7.5rem;
        height: 100vh;
        box-sizing: border-box;
        // border: 1px solid #f0f;
        position: absolute;
        // 上面的样式选择器优化下
        &.top-mid, &.bottom-mid {
            left: 50%!important;
            transform: translateX(-50%)!important;
        }
        &.left-mid, &.right-mid {
            top: 50%!important;
            transform: translateY(-50%)!important;
            // @tips 限制高度让内垂直居中
            height: 13.34rem!important;
        }
        // 确保内部配置的子元素可交互
        & > * {
            pointer-events: auto;
        }
    }

    &.isPC {
        width: 100vw!important;
        max-width: 19.2rem!important;
        .move-container {
            width: 100vw!important;
            max-width: 19.2rem!important;
            // @tips 限制高度让内垂直居中
            &.left-mid, &.right-mid {
                height: 10.8rem!important;
            }
        }
    }
}
</style>
